export default __webpack_public_path__ + "static/media/map.7db6aa10.png";